$(function () {
  $('.intro').fitVids()
  $('.content').fitVids()
})
